import { appendLeadingZeros } from './appendLeadingZeros';

export const convertTime = (time: number): string => {
  const date = new Date(time);
  const day = appendLeadingZeros(String(date.getDate()));
  const month = date.toLocaleString('en', { month: 'short' });
  const year = date.getFullYear();
  const hours = appendLeadingZeros(String(date.getHours()));
  const minutes = appendLeadingZeros(String(date.getMinutes()));

  return `${hours}:${minutes}, ${day} ${month} ${year}`;
};

export const convertToUTCTime = (time: number): string => {
  const date = new Date(time);
  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear();
  const hours = appendLeadingZeros(String(date.getUTCHours()));
  const minutes = appendLeadingZeros(String(date.getUTCMinutes()));

  return `${month}/${day}/${year} ${hours}:${minutes} (UTC)`;
};

export const convertMillisecondsToUTCDate = (value: number): string => {
  const d = new Date(value);
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const yy = String(d.getUTCFullYear()).slice(-2);

  return `${mm}/${yy}`;
};
